/*global dataLayer*/
/**
 * @overview Behaviour for the analytics module.
 *
 * @module analytics
 */

import $ from 'qwery';

export function initAnalytics () {
    const eventActionAttr = 'data-analytics-event-action';
    const eventLabelAttr = 'data-analytics-event-label';

    const elements = $(`[${eventActionAttr}][${eventLabelAttr}]`);

    elements.forEach(
        e => {
            const eventAction = e.attributes[eventActionAttr].value;
            const eventLabel = e.attributes[eventLabelAttr].value;

            if (eventAction && eventLabel) {

                const trackOnce = e.hasAttribute('data-analytics-track-once');

                let hasFocused = false;
                e.addEventListener('focus',
                    () => {
                        if ((trackOnce && !hasFocused) || !trackOnce) {
                            dataLayer.push({
                                event: 'trackEvent',
                                eventCategory: 'engagement',
                                eventLabel,
                                eventAction
                            });

                            hasFocused = true;
                        }
                    });
            }
        }
    );
}

(function () {
    initAnalytics();
}());
